import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./ProductsBody.module.css";
import { useProducts } from "../../../context/ProductsContext";
import TitleH2 from "../../../components/TitleH2/TitleH2";
import Product from "./Product";

function ProductsBody() {
  const products = useProducts();
  const { category } = useParams();
  const [productsTitle, setProductsTitle] = useState("");

  let newProducts = [];
  const [showingProducts, setShowingProducts] = useState(newProducts);

  useEffect(() => {
    navigatesProducts(products, category == undefined ? "Products" : category);
    setShowingProducts([...newProducts]);
    // newProducts = [];
  }, [category, products]);

  const navigatesProducts = (p, compare) => {
    p.forEach((e) => {
      if (e.name && e.name == compare) {
        extractProducts(e);
        setProductsTitle(e.title);
      } else if (e.childs) {
        navigatesProducts(e.childs, compare);
      }
    });
  };

  const extractProducts = (p) => {
    p.childs
      ? p.childs.forEach((e) => {
          e.list
            ? e.list.map(
                (j) => j.stock && j.stock != 0 && newProducts.push(...[j])
              )
            : extractProducts(e);
        })
      : p.list &&
        p.list.map((j) => j.stock && j.stock != 0 && newProducts.push(...[j]));
  };

  return (
    <>
      <div className={styles.ProductsBodyCont}>
        <div className={styles.ProductsBody}>
          <TitleH2>{productsTitle}</TitleH2>
          <div className={styles.showingProdaucts}>
            <ul className={styles.showingProdauctsUl}>
              {showingProducts.length > 0 ? (
                showingProducts.map((e, index) => (
                  <Product product={e} key={index} />
                ))
              ) : (
                <p>محصولی یافت نشد</p>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductsBody;
